import { Controller } from '@hotwired/stimulus'
import { dispatcher } from './pub_controller'

export class DeclineFormController extends Controller {
  static targets = ['otherReasonInput', 'submitButton']
  static values = {
    url: String,
  }

  declare readonly urlValue: string
  declare readonly otherReasonInputTarget: HTMLElement
  declare readonly submitButtonTarget: HTMLButtonElement
  private selectedReasons: string[] = []

  connect() {
    const textarea = this.otherReasonInputTarget.querySelector('textarea')
    if (textarea) {
      textarea.addEventListener('input', () => this.validateForm())
    }
  }

  handleReasonChange(event: CustomEvent) {
    this.selectedReasons = event.detail.value
    const hasOther = this.selectedReasons.includes('other')

    this.otherReasonInputTarget.style.display = hasOther ? 'block' : 'none'
    if (hasOther) {
      const textarea = this.otherReasonInputTarget.querySelector('textarea')
      textarea?.focus()
    }

    this.validateForm()
  }

  validateForm() {
    const hasValidSelection =
      this.selectedReasons.length > 0 && this.selectedReasons[0] !== ''
    const hasOther = this.selectedReasons.includes('other')
    const textarea = this.otherReasonInputTarget.querySelector(
      'textarea',
    ) as HTMLTextAreaElement

    let isValid = hasValidSelection
    if (hasOther) {
      isValid = isValid && textarea?.value.trim() !== ''
    }

    this.submitButtonTarget.disabled = !isValid
  }

  validateSubmit(event: Event) {
    const hasOther = this.selectedReasons.includes('other')
    const textarea = this.otherReasonInputTarget.querySelector(
      'textarea',
    ) as HTMLTextAreaElement

    if (
      this.submitButtonTarget.disabled ||
      (hasOther && textarea?.value.trim() === '')
    ) {
      event.preventDefault()
    }
  }

  openModal() {
    dispatcher(this, 'turbo-modal-get', 'turbo-modal', this.urlValue)
  }
}
